// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import formEditorReducer from '../admin/FormEditor/store/formEditorSlice';

export const store = configureStore({
  reducer: {
    formEditor: formEditorReducer
  }
});